import { McLoadingIndicator } from '@maersk-global/mds-react-wrapper';

interface LoadingIndicatorProps {
  isFullScreen?: boolean;
}

export const LoadingIndicator = ({ isFullScreen }: LoadingIndicatorProps) => {
  if (isFullScreen) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
        }}
      >
        <McLoadingIndicator />
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
      }}
    >
      <McLoadingIndicator />
    </div>
  );
};
